import objectAssign from 'object-assign';
import {
AUTOCOMPLETE
        } from './../actions/search-actions';

const defaultState = {
    results: null
};

export default function (state = defaultState, action) {

    //array( 'sectors' => $sectors, 'sectorsCount' => $sectorsCount, 'products' => $products, 'productCount' => $productsCount );

    switch (action.type) {
        case AUTOCOMPLETE:
            return objectAssign({}, state, {
                results: action.payload
            });
            break;
        default:
            return state;

}

}
